import renderChildren from "../../../../utils/renderChildren";

import useInstantSearchDataTableHits from "./hooks/useInstantSearchDataTableHits";

export default function InstantSearchHits({ children, transformItems }) {
	const { hits, results } = useInstantSearchDataTableHits({ transformItems });

	return renderChildren(children, { hits, results, data: hits });
}
